import PropTypes from "prop-types";
import cn from "classnames";

import { useItineraryTheme } from "@pageComponents/itineraries/themes";
import { ImgixNextBackground } from "@components/imgixNextBackground";
import { ArrowDownFill } from "@icons";

import { useScreens } from "@utils/component";

const sizes = {
  sm: { w: 380, h: 820 },
  md: { w: 1080, h: 810 },
  lg: { w: 1080, h: 810 },
  xl: { w: 1440, h: 900 },
  "2xl": { w: 1920, h: 1080 },
};

function Header({ heading, subheading }) {
  const theme = useItineraryTheme();

  return (
    <header className="w-full px-2 lg:container text-center">
      <h1
        className={cn(
          "mb-8 md:mb-16 text-xl md:text-2xl font-bold",
          `${theme.text.primary}`
        )}
      >
        Our expert itinerary
      </h1>
      <h2
        className={cn(
          "font-rama text-[80px] md:text-[160px] lg:text-[200px] xl:text-[240px] uppercase font-extrabold tracking-wider overflow-hidden overflow-ellipsis leading-none",
          `${theme.text.primary}`
        )}
      >
        {heading}
      </h2>
      <p className="text-white uppercase font-mencken tracking-wider -mt-2 text-3xl md:text-[72px]">
        {subheading}
      </p>
    </header>
  );
}

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
};

export function Hero({ media = [], heading, subheading, handleNextClick }) {
  const theme = useItineraryTheme();
  const { screen } = useScreens();

  return (
    <section className="h-svh relative">
      {media && media.length > 0 ? (
        <ImgixNextBackground
          priority
          overlay="full"
          src={media[0]?.url}
          className="w-full"
          overlayClasses="w-full flex flex-col items-center justify-center"
          wrapperClasses="w-full"
          imgixParams={{ ...sizes[screen], fit: "crop" }}
        >
          <Header heading={heading} subheading={subheading} />
        </ImgixNextBackground>
      ) : (
        <div
          className={cn(
            "w-full h-full flex flex-col items-center justify-center",
            `${theme.background.tertiary}`
          )}
        >
          <Header heading={heading} subheading={subheading} />
        </div>
      )}

      <button
        type="button"
        className="absolute bottom-0 left-1/2 mx-12 my-24 md:my-12 -translate-x-16 flex justify-center items-center bg-blue-100 h-10 w-10 rounded-full"
        onClick={handleNextClick}
      >
        <span className="sr-only">Scroll to next section</span>
        <ArrowDownFill className="w-5 h-5 rotate-180 text-blue" />
      </button>

      {media && media[0]?.credit && (
        <p className="absolute left-2 bottom-0 transform -translate-y-2 w-content p-1 m-0 bg-black bg-opacity-80 text-white text-xs leading-tight rounded-sm">
          {media[0].credit}
        </p>
      )}
    </section>
  );
}

Hero.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  media: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      credit: PropTypes.string,
      url: PropTypes.string.isRequired,
    })
  ),
};
